import { DatePicker, type DatePickerProps } from "@mui/x-date-pickers";
import { type Moment } from "moment";
import moment from "moment";

import { useFieldContext } from "components/Forms/AppForm";

interface DateFieldProps extends DatePickerProps<Moment> {
  label: string;
}

const DateField = ({ label, slots, slotProps, ...rest }: DateFieldProps) => {
  const field = useFieldContext();

  const value = field.state.value ? moment(field.state.value) : null;
  return (
    <DatePicker
      label={label}
      slotProps={{
        field: { clearable: true },
        ...slotProps,
      }}
      onChange={(value) =>
        field.handleChange(value ? value.format("MM/DD/YYYY") : null)
      }
      value={value}
      slots={{ ...slots }}
      {...rest}
    />
  );
};

export default DateField;
